import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IContentElementDndSub } from '../../ui-testrunner/models';
import { bindFormControls } from '../services/data-bind';
import { FormControl } from '@angular/forms';
import { EditingDisabledService } from '../editing-disabled.service';

@Component({
  selector: 'capture-dnd-style',
  templateUrl: './capture-dnd-style.component.html',
  styleUrls: ['./capture-dnd-style.component.scss']
})
export class CaptureDndStyleComponent implements OnInit {

  @Input() element:IContentElementDndSub;
  @Input() isSetDim:boolean;
  @Input() isHidePos:boolean;
  @Input() isHideId:boolean;
  @Output() change = new EventEmitter();
  @Output() idClick = new EventEmitter();
  
  id = new FormControl();
  x = new FormControl();
  y = new FormControl();
  width = new FormControl();
  height = new FormControl();

  constructor(private editingDisabled: EditingDisabledService) { }

  ngOnInit() {    
    const formControls = [
      {f: this.id,     p:'id' },
      {f: this.x,      p:'x' },
      {f: this.y,      p:'y' },
      {f: this.width,  p:'width' },
      {f: this.height, p:'height' },
    ]
    bindFormControls( <any>this.element, formControls);
    formControls.forEach(fc => {
      fc.f.valueChanges.subscribe(()=>{
        this.change.emit();
      });
    });
    
    this.editingDisabled.registerFormControls(formControls);
  }

  isReadOnly() {
    return this.editingDisabled.isReadOnly();
  }
}
